var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveMoreAnalysis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_258_60797)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2001 8.78529C10.2693 8.94036 10.3502 9.08991 10.4421 9.23262L17.6835 7.79196C17.3883 6.75477 16.8859 5.78822 16.2065 4.95075C15.5272 4.11329 14.685 3.42231 13.731 2.91959C12.777 2.41688 11.7309 2.11287 10.656 2.02596C9.58119 1.93906 8.49987 2.07105 7.47748 2.41396L10.2001 8.78529Z",
    fill: "#155DFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4207 11.1614C9.7892 10.6782 9.2915 10.0419 8.97465 9.31269L6.25132 2.93735C5.21836 3.48302 4.31755 4.24845 3.61229 5.17978C2.90703 6.1111 2.41447 7.18569 2.16927 8.32789C1.92408 9.4701 1.9322 10.6522 2.19308 11.7909C2.45396 12.9296 2.96125 13.9973 3.67925 14.9189C4.39725 15.8404 5.3085 16.5934 6.34887 17.1248C7.38923 17.6562 8.53343 17.9531 9.70092 17.9947C10.8684 18.0362 12.0308 17.8214 13.1063 17.3653C14.1818 16.9092 15.1443 16.2229 15.926 15.3547L10.4207 11.1614Z",
    fill: "#155DFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5768 10.366L16.7374 14.2993C17.5622 13.017 18.0005 11.5246 18.0001 9.99997C17.999 9.69897 17.981 9.39828 17.9461 9.0993L11.5768 10.366Z",
    fill: "#155DFC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_258_60797"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveMoreAnalysis);
export default __webpack_public_path__ + "static/media/Active More Analysis.394cc404b4ac4367cfc6e2aee101327f.svg";
export { ForwardRef as ReactComponent };